const BASE = 'technical/program-planner';

export const getStageTemplatesApi = () => `${BASE}/stage-config-templates`;
export const createStageTemplateApi = () => `${BASE}/stage-config-templates`;
export const updateStageTemplateApi = (templateId) => `${BASE}/stage-config-templates/${templateId}`;
export const deleteStageTemplateApi = (templateId) => `${BASE}/stage-config-templates/${templateId}`;

export const getTemplateStagesApi = (templateId) => `${BASE}/stage-config-templates/${templateId}/stages`;
export const createTemplateStageApi = (templateId) => `${BASE}/stage-config-templates/${templateId}/stages`;
export const reorderTemplateStagesApi = (templateId) => `${BASE}/stage-config-templates/${templateId}/stages/reorder`;
export const updateStageApi = (stageId) => `${BASE}/stage-config/${stageId}`;
export const deleteStageApi = (stageId) => `${BASE}/stage-config/${stageId}`;

export const getTransitionsApi = () => `${BASE}/transitions`;
export const createTransitionApi = (fromStageId) => `${BASE}/stage-config/${fromStageId}/transitions`;
export const updateTransitionApi = (transitionId) => `${BASE}/transitions/${transitionId}`;
export const deleteTransitionApi = (transitionId) => `${BASE}/transitions/${transitionId}`;

export const createTransitionGuardApi = (transitionId) => `${BASE}/transitions/${transitionId}/guards`;
export const updateTransitionGuardApi = (guardId) => `${BASE}/guards/${guardId}`;
export const deleteTransitionGuardApi = (guardId) => `${BASE}/guards/${guardId}`;

export const createTransitionActionApi = (transitionId) => `${BASE}/transitions/${transitionId}/actions`;
export const updateTransitionActionApi = (actionId) => `${BASE}/actions/${actionId}`;
export const deleteTransitionActionApi = (actionId) => `${BASE}/actions/${actionId}`;
